import { GenericService } from './Generic.service';

export class TipoEnsinoService extends GenericService {
    readonly URI: string = '/v1/tipoEnsino';

    constructor() {
        super();
        this.setUri(this.URI);
    }

    public getAll() {
        return this.get();
    }
}
